function Banner({ text, visible }) {
  return <div className={`top-banner ${visible ? "visible" : ""}`}>{text}</div>;
}

export default Banner;
